import React, { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom';
import { adminLogin } from '../../api/auth';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ViewIcon from '../../utils/media/icons/view_icon.png';

const Login = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [remember, setRemember] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    // Error states
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validatePassword = (password) => {
        const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        return passwordRegex.test(password);
    };

    const handleLogin = (e) => {
        e.preventDefault();

        setEmailError('');
        setPasswordError('');

        let isValid = true;
        // Email validation
        if (email === '') {
            setEmailError('Email is required.');
            isValid = false;
        } else if (!validateEmail(email)) {
            setEmailError('Invalid email format.');
            isValid = false;
        }
        // Password validation
        if (password === '') {
            setPasswordError('Password is required.');
            isValid = false;
        } else if (!validatePassword(password)) {
            setPasswordError(
                // 'Password must be at least 8 characters long, include at least one uppercase letter, one number, and one special character.'
                'Please enter a valid password.'
            );
            isValid = false;
        }

        if (isValid) {
            adminLogin({ email, password }, dispatch, navigate, remember, toast);
        }
    };

    return (
        <div className='w-screen h-screen flex justify-between items-center p-5 gap-5'>
            <div className='h-full basis-1/2 rounded-3xl py-5 flex flex-col items-center bg-[radial-gradient(_109.97%_217.38%_at_0%_0%,_#f2fff7_0%,_#a1fbc0_68.68%,_#81f7a9_100%_)]'>
                <div className='place-self-start flex justify-start items-center'>
                    <img src={require('../../utils/media/logo.png')} alt="climate crusaders" className='h-16' />
                    <h1 className='text-primary font-extrabold text-lg'>Climate Crusaders</h1>
                </div>
                <div className='h-full flex justify-center items-center'>
                    <img src={require('../../utils/media/login_page.png')} className='place-self-center' alt="" />
                </div>
            </div>
            <div className='rounded-3xl shadow-lg basis-1/2 flex flex-col justify-start items-center py-20 px-14'>
                <h1 className={`text-primary text-4xl font-semibold`}>Login</h1>
                <form action="" method='post' className='w-full my-10 flex flex-col'>
                    <div className="email flex flex-col w-full">
                        <span className={`${emailError ? 'text-red' : 'text-black'} font-bold text-base`}>Email</span>
                        <input
                            type="email"
                            name="email"
                            id="email"
                            required
                            placeholder='Enter Email'
                            className={`border ${emailError ? 'border-red' : 'border-secondary'} rounded-md px-3 py-2 outline-primary`}
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                        {
                            emailError &&
                            <p className={`${emailError ? 'text-red' : 'text-black'} inline text-base`}>
                                {emailError}
                            </p>
                        }
                    </div>
                    <div className="password flex flex-col w-full mt-5">
                        <span className={`${passwordError ? 'text-red' : 'text-black'} font-bold text-base`}>Password</span>
                        <div className='w-full relative'>
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                id="password"
                                required
                                placeholder='Enter Password'
                                className={`border ${passwordError ? 'border-red' : 'border-secondary'} rounded-md px-3 py-2 outline-primary w-full`}
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                            />
                            <button className="absolute right-1 top-2 rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7 max-w-8" onClick={() => setShowPassword(!showPassword)} type='button'>
                                <img src={ViewIcon} alt="view" />
                            </button>
                        </div>
                        {
                            passwordError &&
                            <p className={`${passwordError ? 'text-red' : 'text-black'} text-base`}>{passwordError}</p>
                        }
                    </div>
                    <div className='flex w-full mt-5 justify-between'>
                        <div className="remember flex justify-center items-center">
                            <input
                                type="checkbox"
                                name="remember"
                                id="remember"
                                className='border border-secondary rounded-md px-3 py-2 accent-primary'
                                value={remember}
                                onChange={() => setRemember(!remember)}
                            />
                            <span className='text-secondary ml-2 font-semibold text-base'>Remember Me</span>
                        </div>
                        <NavLink to={'/forgotpassword'} className='text-primary underline text-base'>
                            Forgot Password?
                        </NavLink>
                    </div>
                    <button className='bg-primary self-end text-lg px-20 py-2 text-white font-bold mt-10 max-w-56 rounded-md border hover:bg-white hover:border hover:text-primary' onClick={handleLogin}>
                        Login
                    </button>
                </form>
            </div>
            <ToastContainer 
                position = "bottom-right"
                autoClose = {1000}
            />
        </div>
    )
}

export default Login;